import { AppBar as RAAppBar, Logout, UserMenu } from "react-admin";

import { SettingsMenuItem } from "@/modules/settings";

export const AppBar = () => (
  <RAAppBar
    userMenu={
      <UserMenu>
        <SettingsMenuItem />
        <Logout />
      </UserMenu>
    }
  />
);
